import request from '../utils/fetch';

// 防抖
export function debounce(fn: any, wait: number) {
  var timer: any = null;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn();
    }, wait);
  };
}

// 获取用户列表
export async function getUserListApi(params: any): Promise<any> {
  return request(`/account/v1/boss/whiteUsers`, {
    tokenFree: false,
    method: 'GET',
    params: params,
  });
}

// 新增用户
export async function createUserApi(params: any): Promise<any> {
  return request(`/account/v1/boss/whiteUsers`, {
    tokenFree: false,
    method: 'POST',
    data: params,
  });
}

// 修改用户
export async function updateUserInfoApi(params: any): Promise<any> {
  return request(`/account/v1/boss/whiteUsers`, {
    tokenFree: false,
    method: 'PUT',
    data: params,
  });
}

// 启用用户
export async function enableUserApi(userId: any): Promise<any> {
  return request(`/account/v1/boss/whiteUsers/${userId}/enable`, {
    tokenFree: false,
    method: 'PUT',
  });
}

// 禁用用户&停用用户
export async function disableUserApi(userId: string): Promise<any> {
  return request(`/account/v1/boss/whiteUsers/${userId}/disable`, {
    tokenFree: false,
    method: 'PUT',
  });
}

// 获取用户权限列表
export async function getUserPerList(params: any): Promise<any> {
  return request(`/account/v1/modules/getByProductCode`, {
    tokenFree: false,
    method: 'GET',
    params: params,
  });
}
